export const queryKeys = {
  base: () => ['stacks'],
};
